import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import * as i1 from '@upr-web-primer/locale';
import { get, isEmpty } from 'lodash-es';

class TcmRftHtmlProcessService {
    constructor(tridionDefaults, appDefaults, defaultValues, globalDefaults, localeService) {
        this.tridionDefaults = tridionDefaults;
        this.appDefaults = appDefaults;
        this.defaultValues = defaultValues;
        this.globalDefaults = globalDefaults;
        this.localeService = localeService;
        const locale = this.localeService.getFromStorage();
        const language = locale.language || get(this.appDefaults, 'DEFAULT_ROUTE_COUNTRY');
        const country = locale.country || get(this.appDefaults, 'DEFAULT_ROUTE_LANGUAGE');
        this.siteRegexp = new RegExp(`href=\\\\\?\\"(\/${this.tridionDefaults.TRIDION_SITE}\/|\/web\/)`, 'gi');
        this.webdataMMRegexp = new RegExp(`src=\\\\\?\\"(\/${this.tridionDefaults.TRIDION_SITE}\/|\/web\/)`, 'gi');
        this.prefixRegexp = new RegExp('href=\\\\?\\"(\\.\\.?/)+', 'gi');
        this.mediaRegexp = new RegExp(`(href=\\\\\?\\")(\/${this.tridionDefaults.TRIDION_SITE}\/[A-Z0-9+&@#\/%?=~_\-|!:,;-]*\.((jpg|JPG|gif|GIF|png|PNG|pdf|PDF|mp4|MP4)))`, 'gim');
        this.prefixReplacement = 'href=\\"' + language + '/' + country + '/';
        this.mediaReplacement =
            get(this.appDefaults, 'TRIDION_WEBDATA') +
                '/' +
                this.tridionDefaults.TRIDION_SITE +
                '/';
        this.richTextRegexp = new RegExp('/index.html', 'gi');
        this.appDirectoryRegexp = new RegExp(`(href=).*(..\/..\/${this.appDefaults.TRIDION_APP_DIRECTORY}\/+)`, 'gi');
        this.contentUrlRegexp = new RegExp(`(href=.")(..\/..\/)((?!${this.appDefaults.TRIDION_APP_DIRECTORY}))`, 'g');
    }
    processTcmData(data) {
        if (!get(data, 'Component.Fields') && data instanceof Array) {
            data = data.map((obj) => {
                return this.ignoreRftProcessing(obj) ? obj : this.cleanTcmData(obj);
            });
        }
        else if (!this.ignoreRftProcessing(data)) {
            data = this.cleanTcmData(data);
        }
        return data;
    }
    ignoreRftProcessing(data) {
        const ctName = get(data, 'ComponentTemplate.CleanTitle');
        if (!ctName) {
            return false;
        }
        const matches = get(this.appDefaults, 'EXCLUDE_RTF_PROCESSOR_CTS', []).filter((item) => ctName.indexOf(item) > -1);
        return !isEmpty(matches);
    }
    cleanTcmData(data) {
        const dataFields = get(data, 'Component.Fields');
        if (dataFields) {
            let fields = JSON.stringify(dataFields);
            let isProcessed = false;
            if (fields.match(this.mediaRegexp) !== null) {
                fields = fields.replace(this.mediaRegexp, '$1' + this.appDefaults.TRIDION_WEBDATA + '$2');
                isProcessed = true;
            }
            if (fields.match(this.siteRegexp) !== null) {
                fields = fields.replace(this.siteRegexp, 'href=\\"');
                isProcessed = true;
            }
            if (fields.match(this.prefixRegexp) !== null) {
                fields = fields.replace(this.prefixRegexp, this.prefixReplacement);
                isProcessed = true;
            }
            if (fields.match(this.contentUrlRegexp) !== null &&
                !!this.globalDefaults.WEB_CONTENT_URL) {
                fields = fields.replace(this.contentUrlRegexp, '$1' + `${this.globalDefaults.WEB_CONTENT_URL}/` + '$2');
                isProcessed = true;
            }
            if (fields.match(this.webdataMMRegexp) !== null) {
                fields = fields.replace(this.webdataMMRegexp, 'src=\\"' + this.mediaReplacement);
                isProcessed = true;
            }
            if (fields.indexOf('href=\\"%%HotelsBookingURL%%') > 0) {
                fields = fields.replace(/href=\\"%%HotelsBookingURL%%/, 'href=\\"' + get(this.defaultValues, 'HOTELS_BOOKING_URL'));
                isProcessed = true;
            }
            if (fields.match(this.richTextRegexp) !== null) {
                fields = fields.replace(this.richTextRegexp, '');
                isProcessed = true;
            }
            if (!!this.appDefaults.TRIDION_APP_DIRECTORY &&
                fields.match(this.appDirectoryRegexp) !== null) {
                fields = fields.replace(new RegExp(`/${this.appDefaults.TRIDION_APP_DIRECTORY}/`, 'g'), '/');
                isProcessed = true;
            }
            if (isProcessed) {
                data.Component.Fields = JSON.parse(fields);
            }
        }
        return data;
    }
}
TcmRftHtmlProcessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmRftHtmlProcessService, deps: [{ token: 'TridionDefaults' }, { token: 'AppDefaults' }, { token: 'DefaultValues' }, { token: 'GlobalDefaults' }, { token: i1.LocaleService }], target: i0.ɵɵFactoryTarget.Injectable });
TcmRftHtmlProcessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmRftHtmlProcessService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmRftHtmlProcessService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultValues']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['GlobalDefaults']
                }] }, { type: i1.LocaleService }]; } });

export { TcmRftHtmlProcessService };
